import * as React from 'react';
import { isEqual } from 'lodash';
import Listing from './listing';
import ListingCard from './listing_card';

import Tiles from '@reverbdotcom/commons/dist/components/tiles';
import { trackView, LISTING_TYPE } from '@reverbdotcom/commons/dist/tracker';

interface Props {
  listings: Listing[];
  showSearchFooter?: boolean;
  pagination?: React.ReactNode;
  heading?: boolean;
  actions?: JSX.Element[];
  children?: React.ReactNode;
  trackName?: string;
  trackContext?: object;
}

export default class GridView extends React.Component<Props, null> {
  static defaultProps: Partial<Props> = {
    showSearchFooter: false,
    pagination: false,
    heading: false,
    trackName: 'GridView',
  };

  componentDidMount() {
    this.trackView();
  }

  componentDidUpdate(prevProps) {
    const listingIds = this.listingIds(this.props.listings);
    const prevListingIds = this.listingIds(prevProps.listings);

    if (isEqual(listingIds, prevListingIds)) { return; }

    this.trackView();
  }

  listingIds(listings) {
    if (!listings) { return []; }
    return listings.map(l => l.id);
  }

  trackView() {
    if (this.props.listings.length === 0) { return; }

    trackView({
      componentName: this.props.trackName,
      type: LISTING_TYPE,
      ids: this.listingIds(this.props.listings),
      context: this.props.trackContext,
    });
  }

  listingViews() {
    return this.props.listings.map((listingJson, index) => {
      const listing = new Listing(listingJson);
      return (
        <ListingCard
          listing={listing}
          key={listing.id}
          trackName={this.props.trackName}
          trackContext={this.props.trackContext}
          position={index}
        />
      );
    });
  }

  renderActions() {
    if (!this.props.actions) { return null; }

    return (
      <div className="listing-grid__heading__actions">
        {this.props.actions}
      </div>
    );
  }

  renderHeading() {
    if (!this.props.heading) { return null; }

    return (
      <div className="listing-grid__heading">
        <h1 className="listing-grid__heading__text">
          {this.props.heading}
        </h1>
        {this.renderActions()}
      </div>
    );
  }

  renderPagination() {
    if (!this.props.pagination) { return null; }

    return (
      <div className="listing-grid__pagination">
        {this.props.pagination}
      </div>
    );
  }

  render() {
    return (
      <section className="listing-grid">
        {this.renderHeading()}
        <Tiles
          fourWideMax
        >
          {this.listingViews()}
        </Tiles>
        {this.renderPagination()}
        {this.props.children}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/grid_view.tsx